import {UserSummary} from '../../../../account/modules/user/api/entity/userSummary.model';

export class ProductRetrocessionRuleModel {
    from: UserSummary;
    to: UserSummary;
    amount: number;
    percentage: number;
}
